module.exports = __webpack_public_path__ + "static/media/template1.f5fafe54.PNG";